<p-timeline *ngIf="this.timelineEvents!=null" [value]="timelineEvents" layout="horizontal" align="bottom">
    <ng-template pTemplate="marker" let-event>
                        <span class="custom-marker">
                            <i [ngClass]="event.icon"
                               [style.color]="event.color"
                               [style.font-size]="event.iconSize"></i>
                        </span>
        {{ event.name }}
    </ng-template>
</p-timeline>
<p-messages 
    [(value)]="messages!" 
    *ngIf="selected?.idSectorProyecto === 1" 
    [showTransitionOptions]="'200ms'" 
    [hideTransitionOptions]="'200ms'" 
    [enableService]="false" styleClass="text-2xl" [escape]="false"/>
<div *ngIf="this.selected!=null" class="flex flex-column md:flex-row justify-content-between align-items-center mb-4">
    <div class="flex flex-column text-center md:text-left">
        <span class="text-700 text-2xl mb-2 font-bold">SOLICITUD #{{ selected?.numeroExpediente }}</span>
        <span class="text-600 text-xl mb-2 font-bold">{{ this.selected.nombre }}</span>
        <span class="text-600 text-lg block max-h-10rem overflow-y-auto break-words" style="max-width: 740px;">
            {{ selected.descripcion }}
        </span>
    </div>
    <span class="p-input-icon-right mt-2 mb-1">
        <p-button
            *ngIf="is_rp && loginServices.hasRoles(roles_cliente)"
            [routerLink]="[path_cliente]"
            icon="pi pi-home text-2xll"
            [tooltipPosition]="'right'"
            [pTooltip]="label_cliente"
            [style]="{background: 'orange'}"
            styleClass="p-button-rounded p-button-secondary ml-2">
        </p-button>
        <p-button
            *ngIf="is_rp && loginServices.hasRoles(roles_tecnico)"
            [routerLink]="[path_tecnico]"
            [pTooltip]="label_tecnico"
            [tooltipPosition]="'right'"
            icon="pi pi-home text-2xll"
            [style]="{background: 'black'}"
            styleClass="p-button-rounded p-button-secondary ml-2">
        </p-button>
        <p-button
            *ngIf="is_rp && loginServices.hasRoles(roles_not_cliente)"
            [routerLink]="[path_not_cliente]"
            [pTooltip]="label_not_cliente"
            [tooltipPosition]="'right'"
            icon="pi pi-home text-2xll"
            styleClass="p-button-rounded p-button-secondary ml-2">
        </p-button>
        <p-button
            (onClick)="goBack()"
            [label]="goBackLabel"
            icon="pi pi-undo text-2xl"
            styleClass="p-button-info p-button-rounded ml-2">
        </p-button>
        <ng-container *ngIf="initEvaluacionTemplate">
             <ng-container
                 *ngTemplateOutlet="initEvaluacionTemplate; context: {$implicit: evaluacionInit, clickEvent: onItemClickedEval.bind(this, evaluacionInit)}"></ng-container>
        </ng-container>
          <p-button
              *ngIf="btnVerDetalles"
              [routerLink]="['/users/proyectos/ver_proyecto/', this.selected.idProyecto]"
              [queryParams]="{sessionId: sessionId}"
              queryParamsHandling="merge"
              [pTooltip]="'Ir a detalles de proyecto'"
              [tooltipPosition]="'top'"
              icon="pi pi-search text-2xl"
              styleClass="p-button-rounded p-button-secondary ml-2"/>
          <ng-container *ngIf="carritoButtomTemplate" [ngTemplateOutlet]="carritoButtomTemplate"></ng-container>
    </span>
</div>
<div class="flex flex-wrap justify-content-center md:justify-content-end gap-3">
                <span
                    pTooltip="Fecha de creacion del proyecto"
                    class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-clock text-primary mr-2"></i>
                    <span class="text-900">{{ this.selected?.fechaCreacion }}</span>
                </span>
    <span
        pTooltip="Trámites en este proyecto"
        class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-tags text-primary mr-2"></i>
                    <span class="text-900">{{ this.selected?.cantidadTramites }}</span>
                </span>
    <span
        pTooltip="Estado de la solicitud"
        class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-tag text-primary mr-2"></i>
                    <span class="text-900">{{ this.selected?.estadoSolicitud }}</span>
                </span>
    <span *ngIf="this.selected?.idSolicitudTipo==1" [style]="{ background: 'rgb(0, 128, 0)' }"
          pTooltip="Solicitud Integrada"
          class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-list mr-2 text-white"></i>
                    <span class="text-white">Solicitud Integrada</span>
                </span>
    <span *ngIf="this.selected?.idSolicitudTipo==2" [style]="{ background: 'rgb(255, 165, 0)' }"
          pTooltip="Solicitud Individual"
          class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-check-circle mr-2 text-white"></i>
                    <span class="text-white">Solicitud Individual</span>
                </span>
    <span *ngIf="this.selected?.idSolicitudTipo==3" [style]="{ background: 'rgb(0, 0, 0)' }"
          pTooltip="Solicitud Registro Profesional"
          class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-check-circle mr-2 text-white"></i>
                    <span class="text-white">Solicitud Registro Profesional</span>
                </span>
</div>
